import { getRandomOption } from '@/helpers/helpers'
import { getFullHandSetupOptions } from '@/store/router/router'

function getShortcutStandoffs({ shortcuts }) {
  const res = shortcuts.map(i => i.label?.positions || i.positions)
  return res
}
// function getSpotActivePositions({ spot }) {
//   let res = (spot?.players || []).filter(p => !p.is_folded)
//   res = res.map(p => p.position)
//   return res
// }
function getShortcutsPositions({ shortcuts }) {
  let res = shortcuts.map(i => i.label?.positions || i.positions)
  res = res.flat()
  res = [...new Set(res)]
  return res
}
function getShortcutsActionOptions({ shortcuts }) {
  const order = getFullHandSetupOptions().fh_actions

  let res = shortcuts.map(i => i.label?.type || i.type)
  res = [...new Set(res)]
  res = res.sort((a, b) => order.indexOf(a) - order.indexOf(b))
  return res
}
function getShortcut({ shortcuts, positions, actions }) {
  if (positions.length) {
    shortcuts = shortcuts.filter(s => {
      const r = s.positions.every(p => positions.includes(p))
      return r
    })
  }
  if (actions.length) {
    shortcuts = shortcuts.filter(s => {
      const r = actions.includes(s.type)
      return r
    })
  }
  // if(street) {
  //   shortcuts = shortcuts.filter(s => {
  //     const r = s.street === street
  //     return r
  //   })
  // }
  const res = getRandomOption({ options: shortcuts })
  return res
}
function getStandoffs({ heros = [], opponents = [], positions }) {
  // RFI preflop
  if (positions.length === 1) {
    return [positions]
  }
  const l_heros = heros?.length ? heros : positions
  const l_opponents = opponents?.length ? opponents : positions
  let standoffs = l_heros.map(hero => {
    const heroVsopponnets = l_opponents.map(opp => {
      if (opp !== hero) {
        return [hero, opp]
      }
      return null
    })
    return heroVsopponnets.filter(i => i)
  })
  standoffs = standoffs.flat()
  // console.log(standoffs, heros, opponents)
  return standoffs
}

function getAvailableShortcuts({
  shortcuts,
  standoffs = [],
  actions = [],
  heros = [],
  start_spot = 'custom_spot',
  onlyLabels = false,
}) {
  let res = shortcuts
  if (start_spot !== 'custom_spot') {
    res = res.filter(i => (i.label?.street || i.street).toLowerCase() === start_spot)
  }
  if (actions.length) {
    res = res.filter(i => {
      const r = actions.some(a => (i.label?.type || i.type) === a)
      return r
    })
  }
  if (heros.length) {
    res = res.filter(i => heros.some(h => !i?.hero || i?.hero === h))
  }
  if (standoffs.length) {
    // debugger
    res = res.filter(i => {
      const shortcutPositions = i.label?.positions || i.positions
      if (shortcutPositions.length === 1) {
        // RFI preflop
        const r = standoffs.some(standoff => shortcutPositions[0] === standoff[0])
        return r
      }
      const r = standoffs.some(positions => positions.every(p => shortcutPositions.includes(p)))
      return r
    })
  }
  res = res.map(i => ({
    positions: i.label?.positions || i.positions,
    type: i.label?.type || i.type,
    hero: i.label?.hero || i.hero,
    street: (i.label?.street || i.street).toLowerCase(),
    gamemode: i.gamemode,
    id: onlyLabels ? null : i.id, // shortcut_id - gets unique spot in unique tree
    label_id: onlyLabels ? i.id || i.label_id : i.label?.id || i.label_id, // label_id - gets varying spot in similar tree - not used right now
  }))
  // console.log(res)
  // console.log(res.filter(i => i.street === 'preflop'))
  // console.log(res.filter(i => i.street === 'preflop' && i.type === 'vs3bet'))
  return res
}

function getAvailableGames({
  heros = [],
  opponents = [],
  positions = [],
  actions = [],
  shortcuts,
  start_spot,
}) {
  // const l_heros = heros.length ? heros : positions
  // const l_opponents = opponents.length ? opponents : positions
  const standoffs = getStandoffs({ heros, opponents, positions })
  const availableShortcuts = getAvailableShortcuts({
    shortcuts,
    standoffs,
    actions,
    heros,
    start_spot,
  })
  // debugger
  const availablePositions = getShortcutsPositions({ shortcuts: availableShortcuts })
  const availableActions = getShortcutsActionOptions({ shortcuts: availableShortcuts })
  const availableStandoffs = getShortcutStandoffs({ shortcuts: availableShortcuts })

  const heroFirstAvailableStandoffs = availableStandoffs.map(shortcutStandoff => {
    const heroFirstStandoff = standoffs.find(s => s.every(pos => shortcutStandoff.includes(pos)))
    if (heroFirstStandoff) {
      return heroFirstStandoff
    }
    return shortcutStandoff
  })

  const res = {
    // standoffs,
    standoffs: heroFirstAvailableStandoffs,
    shortcuts: availableShortcuts,
    positions: availablePositions,
    actions: availableActions,
  }
  return res
}
function getRandomShortcut({ allShortcuts, start_spot, actions }) {
  const availableShortcuts = getAvailableShortcuts({
    shortcuts: allShortcuts,
    start_spot,
    actions,
  })
  const res = getRandomOption({ options: availableShortcuts })
  return res
}
function getRandomStandoffShortcut({
  allShortcuts,
  start_spot,
  actions,
  heros = [],
  opponents = [],
}) {
  const params = {
    heros,
    opponents,
    shortcuts: allShortcuts,
    start_spot,
    actions,
  }

  const { standoffs, shortcuts } = getAvailableGames(params)

  const standoff = getRandomOption({ options: standoffs })
  const standoffShortcuts = shortcuts.filter(shrt => {
    const shortcutPositions = shrt.positions
    if (shortcutPositions.length === 1) {
      // RFI preflop
      const r = shortcutPositions[0] === standoff[0]
      return r
    }
    const r = standoff.every(sp => shortcutPositions.includes(sp))
    return r
  })
  const standoffShortcut = getRandomOption({ options: standoffShortcuts })
  return { standoff, standoffShortcut }
}
function getRandomAction({ actions, shortcuts }) {
  let res = null
  if (!actions.length) {
    const allActions = getShortcutsActionOptions({ shortcuts })
    res = getRandomOption({ options: allActions })
  } else {
    res = getRandomOption({ options: actions })
  }
  return res
}
function getRandomStandoff({ heros, opponents, shortcuts }) {
  const positions = getShortcutsPositions({ shortcuts })
  const standoffs = getStandoffs({ heros, opponents, positions })
  const res = getRandomOption({ options: standoffs })
  return res
}
export {
  getStandoffs,
  getAvailableShortcuts,
  getShortcutsPositions,
  // getSpotActivePositions,
  getShortcutsActionOptions,
  getShortcut,
  getAvailableGames,
  getRandomShortcut,
  getRandomStandoffShortcut,
  getRandomAction,
  getRandomStandoff,
}
